import styles from "./ContentTitle.module.css";

interface ContentTitleProps {
    title: string;
}

/**
 * @author bakim
 * @date 2024-08-20
 * @remark 항목 별 제목 컴포넌트
 * @param {string} title(required) : 스크린 제목
 */
function ContentTitle(props: ContentTitleProps) {
    return (
        <div className={styles.container}>
            <h2 className={styles.title}>{props.title}</h2>
        </div>
    );
}

export default ContentTitle;
